var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.24925 0C1.653 0 1.08113 0.226043 0.65925 0.627779C0.23775 1.02916 0 1.57659 0 2.14473V17.8553C0 18.4234 0.23775 18.9708 0.65925 19.3722C1.08113 19.774 1.653 20 2.24925 20H15.7507C16.3474 20 16.9223 19.774 17.3438 19.3722C17.7656 18.9708 18 18.4234 18 17.8553V2.14473C18 1.57659 17.7656 1.02916 17.3438 0.627779C16.9223 0.226043 16.3474 0 15.7507 0H2.24925ZM2.24925 1.42982H15.7507C15.951 1.42982 16.1407 1.50481 16.2817 1.63908C16.4224 1.77299 16.5015 1.95368 16.5015 2.14473V17.8553C16.5015 18.0463 16.4224 18.227 16.2817 18.3609C16.1411 18.4952 15.951 18.5702 15.7507 18.5702H2.24925C2.049 18.5702 1.86225 18.4952 1.72125 18.3609C1.58063 18.227 1.5015 18.0463 1.5015 17.8553V2.14473C1.5015 1.95368 1.58063 1.77299 1.72125 1.63908C1.86225 1.50481 2.049 1.42982 2.24925 1.42982Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3738 5.00147C5.96317 5.00111 5.62455 5.32214 5.62305 5.71352V5.71388C5.62305 6.10597 5.96167 6.42843 6.37305 6.42843H11.6238C12.0352 6.42843 12.3738 6.10597 12.3738 5.71388V5.71352C12.3727 5.32214 12.034 5.00111 11.623 5.00147H6.3738Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3738 9.28491C6.3738 9.28491 6.37342 9.28491 6.37305 9.28491C5.96167 9.28491 5.62305 9.60737 5.62305 9.99911V10.0005C5.62305 10.3926 5.96167 10.7147 6.37305 10.7147H11.6238C12.0352 10.7147 12.3738 10.3926 12.3738 10.0005V9.99911C12.3738 9.60737 12.0352 9.28491 11.6238 9.28491C11.6234 9.28491 11.6234 9.28491 11.623 9.28491H6.3738Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3738 13.5715C6.3738 13.5715 6.37342 13.5715 6.37305 13.5715C5.96167 13.5715 5.62305 13.894 5.62305 14.2857V14.2864C5.62455 14.6778 5.96317 14.9989 6.3738 14.9985H11.623C12.034 14.9989 12.3727 14.6778 12.3738 14.2864C12.3738 14.2864 12.3738 14.2861 12.3738 14.2857C12.3738 13.894 12.0352 13.5715 11.6238 13.5715C11.6234 13.5715 11.6234 13.5715 11.623 13.5715H6.3738Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.9b9de825f3e9d58297d23a2060e3643c.svg";
export { ForwardRef as ReactComponent };